import { APIClient } from "./api_helper";

// Getter — нэвтэрсэн session-оор мэдээлэл цуглуулах тусдаа систем.
// IKHNUDEN-ий хуучин scraper (/v2/scraper, /v2/posts)-аас бүрэн ТУСДАА API.
const api = new APIClient();

const B = "/getter";

// Данснууд (avatar)
export const getGetterAccounts = (platform) =>
  api.get(B + "/accounts", platform ? { platform } : undefined);
export const addGetterAccount = (data) => api.create(B + "/accounts", data);
export const updateGetterAccount = (id, data) => api.put(B + "/accounts/" + id, data);
export const deleteGetterAccount = (id) => api.delete(B + "/accounts/" + id);
export const loginGetterAccount = (id) => api.create(B + "/accounts/" + id + "/login", {});

// Судалгаа ажиллуулах — судалгаа өөрөө «Нэгдсэн судалгаа → Удирдлага» (tasks)
// дээр үүсдэг тул энд зөвхөн эхлүүлэх/зогсоох/төлөв л байна.
export const runGetterForTask = (taskId) => api.create(B + "/tasks/" + taskId + "/run", {});
export const stopGetterForTask = (taskId) => api.create(B + "/tasks/" + taskId + "/stop", {});
export const getGetterTaskStatus = () => api.get(B + "/tasks/status");

// Судалгаа × платформ бүрийн цуглуулгын явц (SuperAdmin).
// `ids` өгвөл зөвхөн тэдгээрийг — картан дээр харагдаж буй судалгаанууд.
export const getGetterTaskProgress = (ids) =>
  api.get(B + "/tasks/progress" + (ids && ids.length ? "?ids=" + ids.join(",") : ""));
// Судалгааны хөнгөн жагсаалт (нэр, priority, platforms) — хяналтын
// самбарын таб/сонголтод. `all=1` бол getter.enabled бүгдийг, эс бол зөвхөн Urgent.
export const getGetterTasksList = (all) => api.get(B + "/tasks/list" + (all ? "?all=1" : ""));
// Сүүлд цугласан бодит агуулга (текст/эх сурвалж/судалгаа) — хяналтын самбарын
// шууд урсгал. `params`: { taskId, platform, limit }.
export const getGetterRecentPosts = (params) => api.get(B + "/posts/recent", params);
// Багц (batch) тус бүрээр бүлэглэсэн ажлын түүх — «№N гүйлт хэзээ эхэлж хэзээ
// дуусав». `params`: { taskId, limit }.
export const getGetterBatches = (params) => api.get(B + "/batches", params);
// Платформ тус бүрийн эрүүл мэнд (сүүлийн 24ц) — selector магадгүй эвдэрсэн
// (0 үр дүн) эсвэл avatar session хүчингүй болсныг тод илрүүлнэ.
export const getGetterHealth = () => api.get(B + "/health");
// Судалгааны getter тохиргоо (горим, платформ, огнооны шүүлт) — зөвхөн SuperAdmin
export const getTaskGetterSettings = (taskId) => api.get(B + "/tasks/" + taskId + "/settings");
export const saveTaskGetterSettings = (taskId, data) =>
  api.put(B + "/tasks/" + taskId + "/settings", data);

// Ажлууд
export const getGetterJobs = (params) => api.get(B + "/jobs", params);
export const addGetterJob = (data) => api.create(B + "/jobs", data);
export const cancelGetterJob = (id) => api.create(B + "/jobs/" + id + "/cancel", {});

// ⚠️ Цуглуулсан нийтлэл нь ТУСДАА хадгалагдахаа больсон — шууд IKHNUDEN-ий
// `posts`-д бичигдэж, «Нэгдсэн судалгаа → Нийтлэлүүд» хуудсаар харагдана.

// Тохиргоо
export const getGetterRapidConfigs = () => api.get(B + "/rapidapi");
export const saveGetterRapidConfig = (data) => api.create(B + "/rapidapi", data);
// DOM selector — платформын UI өөрчлөгдвөл кодыг deploy хийхгүйгээр эндээс засна
export const getGetterSelectors = () => api.get(B + "/selectors");
export const saveGetterSelector = (key, value) => api.create(B + "/selectors", { key, value });

export const getGetterNewsSites = () => api.get(B + "/news-sites");
export const saveGetterNewsSite = (data) => api.create(B + "/news-sites", data);
export const deleteGetterNewsSite = (id) => api.delete(B + "/news-sites/" + id);
// Домэйны логог Google favicon эх сурвалжаас (дахин) татаж кэшлэнэ
export const fetchGetterNewsSiteLogo = (id) => api.create(B + "/news-sites/" + id + "/logo", {});
// Хэрэглэгчийн сонгосон зургийг (base64 data URL) шууд оруулна
export const uploadGetterNewsSiteLogo = (id, dataUrl) =>
  api.create(B + "/news-sites/" + id + "/logo-upload", { dataUrl });
